import { Component, computed, effect, inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Identity } from '@xanadu/model';
import { AuthService, DataService } from '@xanadu/service';
import { switchMap } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { PasswordDialogComponent } from '../password-dialog/password-dialog.component';
import { Router } from '@angular/router';
import { CommonSignal, TabSignalAction } from '@xanadu/signal';
import { Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthSignal, TabSignal } from '@xanadu/signal';

@Component({
    selector: 'app-head',
    templateUrl: './head.component.html',
    styleUrls: ['./head.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeadComponent {
    private readonly router = inject(Router);
    private readonly tabSignal = inject(TabSignal);
    private readonly commonSignal = inject(CommonSignal);
    private readonly authSignal = inject(AuthSignal);
    private readonly authService = inject(AuthService);
    private readonly dataService = inject(DataService);
    private readonly dialog = inject(MatDialog);

    public identity?: Identity;

    private search$: Subject<string> = new Subject<string>();
    public hidden = computed((): boolean => !this.commonSignal.tab()?.search);

    constructor(
    ) {
        effect(() => {
            this.identity = this.authSignal.identity();
        });

        this.search$
            .pipe(
                takeUntilDestroyed(),
                switchMap(id => this.dataService.locate(id)))
            .subscribe(ids  => {
                if (ids?.length) {
                    this.tabSignal.seek.content.set(ids);
                }
            });
    }

    public doneSearch(result: any) {
        const id = result.id;
        this.search$.next(id);
    }

    public changePassword() {
        this.dialog.open(PasswordDialogComponent, {
            width: '600px',
            data: this.identity
        },);
    }

    public logout() {
        this.authService.logout();

        window.location.replace('/login');
    }
}
